
var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
    bottomOffset = 1000; // the distance (in px) from the page bottom when you want to load more posts
module.exports = {
  init: function($) { 

        var query = $('#date_query').data('date_query');
        var getQueryVariable = function(variable)
        {
               var query = window.location.search.substring(1);
               var vars = query.split("&");
               for (var i=0;i<vars.length;i++) {
                       var pair = vars[i].split("=");
                       if(pair[0] == variable){return pair[1];}
               }
               return(false);
        }
        if( !query ) {
          query = {
            date_query: {
              after: '',
              before: ''
            }
          };
        }
        var paged = 2;
        var loadmore = true;
        if( getQueryVariable('meetingtype') == 'past' ) {
          var today = new Date();
          var dd = today.getDate();
          var mm = today.getMonth();
          var yyyy = today.getFullYear();
          if(dd<10) 
          {
              dd='0'+dd;
          } 
          if(mm<10) 
          {
              mm='0'+mm;
          } 
          var todayStr = yyyy + '-' + mm + '-' + dd;
          $(window).scroll( () => {
            if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && loadmore && $('#board_meetings_container .card').length >= 9 ){
              $.post( '/wp-json/api/v2/board_meetings', {
                startdate: query['date_query']['after'],
                enddate: query['date_query']['before'] ? query['date_query']['before'] : todayStr,
                paged: paged
              }, (result) => {
                if( result == '' ) {
                  loadmore = false;
                } else {
                  $('#board_meetings_container').append( $.parseHTML( result ) );
                  paged = paged + 1
                  console.log(paged);
                }
              });
            }
            if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && loadmore && $('#board_meetings_container tr').length >= 9 ){
              $.post( '/wp-json/api/v2/board_meetings_list', {
                startdate: query['date_query']['after'],
                enddate: query['date_query']['before'] ? query['date_query']['before'] : todayStr,
                paged: paged
              }, (result) => {
                if( result == '' ) {
                  loadmore = false;
                } else {
                  $('#board_meetings_container').append( $.parseHTML( result ) );
                  paged = paged + 1
                  console.log(paged);
                }
              });
            }
          });
        }
    }
}


// WEBPACK FOOTER //
// ./beansprout/assets/js/_load_more.js